import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = null as string | null;

const slice = createSlice({
  name: 'pendingRedirect',
  initialState,
  reducers: {
    setPendingRedirect(_state, action: PayloadAction<string>) {
      return action.payload;
    },
    clearPendingRedirect() {
      return null;
    },
  },
});

export const { setPendingRedirect, clearPendingRedirect } = slice.actions;
export default slice.reducer;
